import { Box, CardHeader as MuiCardHeader, styled } from '@mui/material';

export const CardHeader = styled(MuiCardHeader, {
  shouldForwardProp: (prop) => prop !== 'success',
})<{ success?: boolean }>(({ theme, success }) => ({
  '& .MuiCardHeader-title': {
    color: success ? theme.palette.green.contrastText : 'inherit',
    fontSize: 14,
    fontWeight: 500,
  },
  backgroundColor: success ? theme.palette.green.backgroundLight : theme.palette.grey[500],
  borderBottom: `1px solid ${theme.palette.grey[600]}`,
}));

export const Anchor = styled(Box)({
  display: 'block',
  position: 'relative',
  // height of header
  top: '-64px',
  visibility: 'hidden',
});

export const Pre = styled('pre')(({ theme }) => ({
  display: 'block',
  padding: '9.5px',
  margin: 0,
  fontSize: 13,
  color: theme.palette.black.main,
  backgroundColor: theme.palette.grey[500],
  border: `1px solid ${theme.palette.grey[600]}`,
  borderRadius: 4,
}));
